// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Sm6JE","title":"styles_title__iz09s","gamesContainer":"styles_gamesContainer__RiffG","loadMoreWrap":"styles_loadMoreWrap__FUnr_"};